var moment = require('moment');
var $ = require('jquery');

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.hstri = factory());
}(this, (function () { 'use strict';

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

















var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var queryMichelangelo = function (opts, ajax) {
    var data = buildQuery({
        start: opts.start,
        end: opts.end,
        series: opts.instrument,
        frequency: opts.frequency,
        entitlementToken: opts.entitlementToken
    });
    var promise = sendQuery(data, ajax).fail(function (err) {
        if (err.responseJSON && err.responseJSON.Message) {
            throw 'Message from API: ' + err.responseJSON.Message;
        }
        throw err.statusText;
    });

    if (opts.raw !== true) {
        promise = promise.then(extractValues).then(combineValues).then(extractMetadata).fail(function (err) {
            console.error(err);
            throw 'Error parsing data';
        });

        // .then(fillBlanks);
    }

    if (opts.callback) {
        promise.done(opts.callback);
    }

    return promise;
};

function extractValues(data) {
    return data.Series.map(function (d, i) {
        return {
            points: d.DataPoints.map(function (p, j) {
                var points = {};
                d.DesiredDataPoints.forEach(function (dataPointType, k) {
                    points[dataPointType] = p[k];
                });
                return points;
            }),
            ticks: data.TimeInfo.Ticks,
            raw: data
        };
    });
}

function combineValues(data) {
    return data.map(function (d, i) {
        var combined = d.points.map(function (p, j) {
            p.date = d.ticks[j];
            return p;
        });
        d.data = combined.map(function (p) {
            return [p.date, p.Last];
        });
        d.fullData = combined;
        return d;
    });
}

function extractMetadata(data) {
    return data.map(function (d, i) {
        var raw = d.raw.Series[i];
        d.ticker = raw.Ticker;
        d.name = raw.CommonName;
        return d;
    });
}

/*
opts:
- start (date)
- end (date)
- series (array of instrument keys)
*/
function buildQuery(opts) {
    var series = opts.series.map(function (symbol) {
        return {
            "Key": symbol,
            "Dialect": "Charting",
            "Kind": "Ticker",
            "SeriesId": "s1",
            "DataTypes": ["Open", "High", "Low", "Last", "PercentChange"]
        };
    });
    return defineProperty({
        "Series": series,
        "StartDate": opts.start.valueOf(),
        "EndDate": opts.end.valueOf(),
        "Step": opts.frequency,
        "TimeFrame": "D1",
        "EntitlementToken": opts.entitlementToken,
        "IncludeMockTick": true,
        "FilterNullSlots": true,
        "FilterClosedPoints": true,
        "IncludeClosedSlots": false,
        "IncludeOfficialClose": true,
        "InjectOpen": false,
        "ShowPreMarket": false,
        "ShowAfterHours": false,
        "UseExtendedTimeFrame": true,
        "WantPriorClose": true,
        "IncludeCurrentQuotes": true,
        "ResetTodaysAfterHoursPercentChange": false
    }, 'TimeFrame', "custom");
}

function sendQuery(data, ajax) {
    var request = ajax({
        url: "https://api.wsj.net/api/michelangelo/timeseries/history?ckey=" + data.EntitlementToken.slice(0, 10),
        type: "POST",
        dataType: "json",
        data: JSON.stringify(data),
        beforeSend: function beforeSend(request) {
            request.setRequestHeader("Dylan2010.EntitlementToken", data.EntitlementToken);
            request.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
        }
    });
    return request;
}

var queryDylan = function (opts, ajax) {

    var query = buildQuery(opts);
    var url = 'https://api.wsj.net/api/dylan/dataseries/v2/pricing?id=' + query + '&ckey=57494d5ed7&Dylan2010.EntitlementToken=57494d5ed7ad44af85bc59a51dd87c90&json=true';

    var promise = ajax({
        url: url,
        type: "GET",
        crossDomain: true,
        headers: {
            "Accept": "application/json",
            "Dylan2010.EntitlementToken": '57494d5ed7ad44af85bc59a51dd87c90'
        },
        dataType: 'json'
    }).fail(function (err) {
        console.error(err);
        if (typeof $ !== 'undefined') {
            var message = $(err.responseText).find('p:eq(1)').text().split("'")[1];
            throw 'Message from API: ' + message;
        } else {
            throw err.responseText;
        }
    });

    if (opts.raw !== true) {
        promise = promise.then(extractValues).then(processValues).then(extractMetadata$1).fail(function (err) {
            console.error(err);
            throw 'Problem parsing data';
        });
    }

    if (opts.callback) {
        promise.done(opts.callback);
    }

    return promise;

    function extractValues(d) {
        var metadata = d.GetDataSeriesResponse.DataSeriesResponses[0].SeriesMatches[0];
        var values = metadata.DataPoints;
        if (values.length === 0) {
            throw 'Live data is empty.';
        }
        return { metadata: metadata, values: values };
    }

    function processValues(_ref) {
        var metadata = _ref.metadata,
            values = _ref.values;

        var processed = values.map(function (d, i) {
            var date = Date.parse(d.Trading.Last.Time);
            var value = d.Trading.Last.Price.Value;
            return [date, value];
        });
        return [{
            raw: metadata,
            data: processed
        }];
    }

    function buildQuery(opts) {
        /*
        Instruments --> comma separated list of instruments to request formated as follows 
        Ticker|CountryCode|ExchangeIsoCode|InstrumentType
        
        Needed --> pipe separated list of what you want returned possibilities
        AfterHoursTrading, BeforeHourseTrading, Financials, FinancialStatusIndicator, Offers, Trading, TradingStatistics, RealtimeTrading, RealtimeBeforeHoursTrading, RealTimeAfterHoursTrading, CompositeTrading, CompositeBeforeHoursTrading, CompositeAfterHoursTrading, IndustryClassification, BluegrassChannels, TimeZoneInfo, BondSpecific, CurrencySpecific)
        */

        var query = '';

        query += opts.instrument[0] + '|'; // Ticker|CountryCode|ExchangeIsoCode|InstrumentType
        query += opts.start.format('YYYY-MM-DD[T]HH:mm:ss') + '|';
        query += opts.end.format('YYYY-MM-DD[T]HH:mm:ss') + '|';
        query += opts.frequency + '||True';

        return query;

        // EURUSD|US||Currency|'+range[0]+ '|' +range[1] + '|PT1M||True
    }
};

function extractMetadata$1(data) {
    var raw = data[0].raw.Instrument;
    data[0].name = raw.CommonName;
    data[0].ticker = raw.Ticker;
    return data;
}

var fillBlanksWith = function (_ref, moment) {
    var frequency = _ref.frequency,
        fillBlanksWithPrevious = _ref.fillBlanksWithPrevious,
        start = _ref.start,
        end = _ref.end;

    return function (arr) {
        var precisions = {
            P1D: 'day',
            P1Y: 'year',
            P1W: 'week',
            PT1M: 'minute',
            PT1H: 'hour'
        };
        var intervals = {};
        Object.keys(precisions).forEach(function (k) {
            intervals[k] = moment() - moment().subtract(1, precisions[k]);
        });
        var interval = intervals[frequency];

        arr.forEach(function (instr) {

            var data = JSON.parse(JSON.stringify(instr.data));
            var lengthOfTime = end - start;
            var expectedNumberOfTicks = lengthOfTime / interval;
            var expectedTicks = [];
            for (var i = 0; i < expectedNumberOfTicks; i++) {
                expectedTicks.push([start + interval * i, null]);
            }

            var fullTicks = [].concat(data, expectedTicks);
            fullTicks.sort(function (a, b) {
                return a[0] - b[0];
            });
            fullTicks.forEach(function (d) {
                d[0] = moment.utc(d[0]).startOf(precisions[frequency]).valueOf();
            });
            var uniqueTicks = fullTicks.reduce(function (accum, curr, i) {
                var existingIndex = -1;
                var existing = accum.filter(function (d, i) {
                    if (d[0] === curr[0]) {
                        existingIndex = i;
                    }
                    return d[0] === curr[0];
                });
                if (existing.length === 0) {
                    accum.push([curr[0], curr[1]]);
                } else if (existingIndex > -1 && existing[0][1] === null) {
                    accum[existingIndex] = curr;
                }
                return accum;
            }, []);

            var fillWithPreviousValue = createFillerBackTo(instr.ticks[instr.ticks.length - 1]);
            if (fillBlanksWithPrevious) {
                uniqueTicks = uniqueTicks.map(fillWithPreviousValue);
            }

            instr.data = uniqueTicks;
            instr.ticks = uniqueTicks.map(function (d) {
                return d[0];
            });
            instr.points = uniqueTicks.map(function (d) {
                return d[1];
            });
        });

        return arr;
    };

    function createFillerBackTo(d) {
        var date = moment(d);
        return function (d, i, arr) {
            var notFirst = i > 0;
            var isNull = d[1] === null;
            var inPast = moment.utc(d[0]).isBefore(date);
            if (notFirst && isNull && inPast) {
                d[1] = arr[i - 1][1];
            }
            return d;
        };
    }
};

var hstri$2 = function hstri$2(opts, deps) {

    opts = processOpts(opts, deps.moment);

    var promise = void 0;

    if (opts.service === 'dylan') {
        promise = queryDylan(opts, deps.ajax);
    } else {
        promise = queryMichelangelo(opts, deps.ajax);
    }

    if (opts.fillBlanks || opts.fillBlanksWithPrevious) {
        var fillBlanks = fillBlanksWith(opts, deps.moment);
        promise = promise.then(fillBlanks);
    }

    if (opts.raw !== true) {
        promise = promise.then(addSource(opts));
    }

    return promise;
};

function validateFrequency(frequency) {
    // regex from moment.js
    // https://github.com/moment/moment/blob/develop/src/lib/duration/create.js#L14
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
    var match = frequency.match(isoRegex);
    if (match === null || !frequency) {
        throw '"' + frequency + '" option is not valid. Here are some example time codes:\
P1D  | daily\
P1Y  | yearly\
P1W  | weekly\
PT1M | every minute\
PT1H | every hour\
';
    }
}

function processOpts(opts, moment) {
    var checkDate = createDateChecker(moment);
    var roundToNearestMinute = createMinuteRounder(moment);

    if (!opts.instrument) {
        throw 'No symbol specified';
    }
    if (Array.isArray(opts.instrument) === false) {
        opts.instrument = [opts.instrument];
    }
    if (!opts.start) {
        throw 'No start date specified';
    } else {
        checkDate(opts.start, 'Start date');
    }
    if (opts.end) {
        checkDate(opts.end, 'End date');
    } else {
        opts.end = moment();
    }

    if (opts.start.isSame(opts.end)) {
        if (opts.start.format('HH:mm:ss') === '00:00:00') {
            // if both dates are midnight, assume user wants that full day
            opts.end.endOf('day');
        } else {
            throw 'Start and end dates are exactly the same day and time.';
        }
    }

    opts.start = roundToNearestMinute(opts.start);
    opts.end = roundToNearestMinute(opts.end, true);
    validateFrequency(opts.frequency);

    opts.entitlementToken = opts.entitlementToken || '57494d5ed7ad44af85bc59a51dd87c90';

    return opts;
}

function createDateChecker(moment) {
    return function checkDate(date, name) {
        if (date instanceof moment === false) {
            throw name + ' is not a Moment.js date object. It also needs a timezone explicitly set using the Moment Timezone plugin. Downloads and documentation here: http://momentjs.com/timezone/';
            return false;
        }
        if (date.tz() === undefined) {
            throw name + ' needs a timezone explicitly set using the Moment Timezone plugin. Downloads and documentation here: http://momentjs.com/timezone/';
            return false;
        }
        return true;
    };
}

function createMinuteRounder(moment) {
    return function roundToNearestMinute(date) {
        var roundUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var roundToNearest = 60000; // 1 minutes
        if (roundUp) {
            return moment(Math.ceil(date / roundToNearest) * roundToNearest);
        }
        return moment(Math.floor(date / roundToNearest) * roundToNearest);
    };
}

function addSource(opts) {
    return function (data) {
        console.log(data);
        data.forEach(function (d) {
            d.source = {
                entitlementToken: opts.entitlementToken
            };
        });
        return data;
    };
}

// NOTE: this.moment is set in the entry script

function log(data) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';

    var fmt = format.toLowerCase();
    var output = '';

    console.log(this);

    if (fmt === 'raw') {
        output = JSON.stringify(data);
    } else if (fmt === 'csv') {
        console.log(arrayToCSV(data.data, this.moment));
    } else {
        output = JSON.stringify(data.data);
    }
    console.log(output);
    return output;
}

function arrayToCSV(data, moment) {
    var newArr = data.map(function (d, i) {
        d[0] = moment.tz(d[0], 'America/New_York').format('DD-MM-YY HH:mm:ss');
        return d.join(",");
    });
    newArr.unshift('date,value');
    return newArr.join("\n");
}

var hstri = function hstri(opts) {
    return hstri$2(opts, {
        moment: moment,
        ajax: $.ajax
    });
};
hstri.moment = moment;
hstri.log = log;

return hstri;

})));
//# sourceMappingURL=hstri.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hstri/hstri.js
// module id = 19
// module chunks = 0